export const ID35 = () => {
    return(
        <div>
            <h2 className="servicePage_title">АДРЕСНЫЙ СКЛАД</h2>
            <div className="content" readonly=""><p>
                Функционал системы "1С:WMS Логистика. Управление складом" позволяет оптимизировать процессы и решить
                основные проблемы, актуальные для складских комплексов:
            </p>

                <ul>
                    <li>оптимизация использования складских площадей при размещении и хранении товара;</li>
                    <li>сокращение затрат на складское хранение;</li>
                    <li>сокращение времени и количества ошибок на обработку складских операций;</li>
                    <li>повышение точности и оперативности учета товара;</li>
                    <li>исключение потерь, связанных с критичностью сроков реализации товаров;</li>
                    <li>уменьшение затрат на заработную плату складских работников.</li>
                </ul>

                <p>"1С:WMS Логистика. Управление складом" предназначена для управления процессами складской
                    грузообработки в режиме реального времени, а именно:</p>

                <ul>
                    <li>получения актуальной информации об остатках товара на складе в "онлайн" режиме;</li>
                    <li>оптимизации товарных потоков на складе;</li>
                    <li>управления и оптимизации приемки, размещения, перемещения, отбора, отгрузки и прочих складских
                        операций;
                    </li>
                    <li>контроля работы складского персонала.</li>
                </ul>

                <p>
                    Для создания единого информационного пространства складской и транспортной логистики реализован
                    онлайн обмен данными с решениями "<a href="https://solutions.1c.ru/catalog/tms/features">1С:TMS
                    Логистика. Управление перевозками</a>" и "<a href="https://solutions.1c.ru/catalog/tmsexp/features">1С:Транспортная
                    логистика, экспедирование и управление автотранспортом КОРП</a>". 1С:WMS
                    автоматически планирует задачи на&nbsp;погрузку с учетом порядка выгрузки в&nbsp;процессе
                    доставки.&nbsp;Сотрудники транспортных отделов в&nbsp;реальном
                    времени получают информацию о стадиях обработки заданий на складе.
                </p>

                <p>
                    Управление складскими процессами в режиме реального времени достигается с помощью беспроводных
                    технологий и внедрения соответствующей складской
                    технологической цепочки. Поэтому "1С:WMS Логистика. Управление складом" преимущественно нацелена на
                    использование данных технологий. Основные функции по
                    созданию и обработке складских задач выполняются пользователями с терминалами сбора данных:
                    кладовщиками, сборщиками, комплектовщиками. В функции диспетчера
                    склада входит контроль над исполнением задач и решение нестандартных ситуаций.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/717203350.png" alt=""/>

                <p>
                    В системе возможен учет одного физического склада. При необходимости работы системы на нескольких
                    физических или логических складах, необходимо создавать
                    несколько информационных баз с возможным обменом между собой дублирующийся информацией.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1740722527.png" alt=""/>

                <p>
                    Склад, как правило, разделен на физические зоны, в которых обработка товара подчиняется определенным
                    правилам в зависимости от конструкции стеллажей,
                    используемого оборудования, планировки помещений и т.д.
                </p>

                <p>На практике выделяются и могут участвовать в складском учете следующие зоны склада:</p>

                <ul type="disc">
                    <li>
                        Зона выгрузки. Зона предназначена для размещения поступающих товаров непосредственно после их
                        выгрузки из транспортных средств, например – пандус
                        склада.
                    </li>
                    <li>Зона приемки. Зона предназначена для пересчета товаров, выгруженных из транспортных средств и
                        участвующих в процедуре входного контроля.
                    </li>
                    <li>
                        Зона карантина (контроля качества). Зона предназначена для товаров, проходящих процедуру
                        проверки качества, а также для товаров, возвращенных
                        покупателями до принятия решения об их дальнейшем движении.
                    </li>
                    <li>Зона основного хранения. Зона, предназначенная для хранения товара преимущественно целыми
                        паллетами.
                    </li>
                    <li>Зона отбора. Зона, предназначенная для отбора товара. Обычно это нижний ярус ячеек склада или
                        мезонин.
                    </li>
                    <li>
                        Транзитная зона. Промежуточная зона хранения товара. Транзитная зона может быть выделена для
                        временного хранения товара при перемещениях между зонами.
                    </li>
                    <li>
                        Зона некондиции. Зона предназначена для товаров с потерей товарного вида, с нарушением
                        целостности упаковки, дефектных, с истекшим сроком реализации и
                        т.д.
                    </li>
                    <li>Зона сборки. Зона предназначена сборки комплектов из комплектующих.</li>
                    <li>Зона отгрузки. Зона предназначена для хранения отгружаемых товаров и грузовых единиц до момента
                        их загрузки в транспортные средства.
                    </li>
                    <li>Зона загрузки. Зона предназначена для размещения отгружаемых товаров и грузовых единиц перед их
                        непосредственной загрузкой в транспортные средства.
                    </li>
                </ul>

                <p>
                    <b>Учет товара в адресном пространстве склада</b> в разрезе упаковок, сроков годности, партий,
                    серийных номеров, акцизных марок, качества; учет тары и
                    контроль габаритов товара; АВС/ХYZ анализ; работа с транзитными грузами; учет акцизов; одновременный
                    учет товаров различных типов (например, мерный,
                    штучный, весовой,&nbsp;отрезной и т.д. ); учет требований к температурным режимам
                    хранения,&nbsp; работа с блоками ячеек; учет комплектов.
                </p>

                <p>
                    <b>Учет товаров в разрезе кодов цифровой маркировки и прослеживаемость товаров на складе</b>
                </p>

                <p>
                    При учете товара в разрезе кодов цифровой маркировки товаров (ЦМТ), система требует ввода информации
                    о цифровых кодах при выполнении всех операций с помощью
                    автоматизированных рабочих мест, терминала сбора данных или ручного выполнения задач. Данный
                    функционал обеспечивает:
                </p>

                <ul>
                    <li>
                        <p>получение кодов ЦМТ из основной учетной системы. Возможность приемки кодов ЦМТ вне плана
                            регулируется в Стратегии приемки;</p>
                    </li>
                    <li>
                        <p>возможность генерации и учета кодов цифровой маркировки по собственной, принятой на
                            предприятии, системе маркировки товаров;</p>
                    </li>
                    <li>
                        <p>возможность ведения учета для различной номенклатуры в разрезе кодов ЦМТ - настраивается на
                            уровне Модели учета номенклатуры;</p>
                    </li>
                    <li>
                        <p>возможность ведения учета по одной номенклатуре как в разрезе кодов ЦМТ, так и без –
                            настраивается на уровне Партии товара;</p>
                    </li>
                    <li>
                        <p>движение кодов ЦМТ в рамках стандартных операций;</p>
                    </li>
                    <li>
                        <p>возможность отследить все внутрискладские движения и остатки товаров в разрезе кодов ЦМТ;</p>
                    </li>
                    <li>
                        <p>проведение инвентаризации в разрезе кодов ЦМТ;</p>
                    </li>
                    <li>
                        <p>передачу кодов ЦМТ в основную учетную систему при выполнении операции отгрузки товаров;</p>
                    </li>
                    <li>
                        <p>
                            формирование отчета Остатки в разрезе количества кодов ЦМТ с возможностью расшифровки кодов
                            потребительской и транспортной/логистической упаковки;
                        </p>
                    </li>
                    <li>
                        <p>формирование отчета Движения маркированных товаров – выводит данные о всех движениях по
                            заданному коду ЦМТ.</p>
                    </li>
                </ul>

                <p>
                    Форма ввода информации о кодах ЦМТ предусмотрена для работы с цифровой маркировкой товара и
                    идентична для автоматизированных рабочих мест и ручного
                    выполнения задач. При выполнении задач с терминалом сбора данных на экран выводится запрос на ввод
                    кодов ЦМТ:
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/411794686.png" alt=""/>

                <p>
                    Предусмотрен обмен данными с передачей фактических кодов ЦМТ в корпоративную информационную систему
                    1C:ERP. Управление холдингом, 1С:ERP Управление
                    предприятием, 1C:Комплексная автоматизация, редакция 2, 1С:Управление торговлей, редакция 11 или
                    решений на их основе, поскольку прямое взаимодействие с ГИС
                    по маркируемым товарам осуществляется именно в них.
                </p>

                <p>
                    Приемка. Приемка в доверительном режиме и под заказ (кросс-докинг), предварительный пересчет по
                    местам. Информация о товаре, необходимая для проведения
                    регламентных мероприятий по подготовке склада к приему поставки заносится в документ "Ожидаемая
                    приемка". На основании данной информации на складе может
                    быть запланировано привлечение дополнительных сотрудников для приемки товара, подготовка складских
                    площадей к размещению товара, как в зоне приемки, так и в
                    основной зоне хранения. Возможными источниками поступления товара могут быть поставщики (в случае
                    прихода товара от поставщика), клиенты (в случае возврата
                    товара от клиента), другие склады компании (в случае перемещения между складами в рамках одной
                    компании), производственные площадки (в случае поступления
                    готовой продукции из производства). Вновь прибывший на склад товар может быть предварительно
                    пересчитан по местам при выгрузке из транспортного средства.
                    Для корректного пересчета и идентификации прибывших контейнеров с товаром, они подлежат маркировке
                    этикетками, содержащими идентификационные номера
                    контейнеров. Этикетки на контейнеры могут быть подготовлены заранее или распечатаны в процессе
                    пересчета с помощью терминала сбора данных и мобильного
                    принтера печати этикеток.
                </p>

                <p>
                    Данный процесс в системе оформляется документом "Предварительная приемка". "Предварительная приемка"
                    может выполняться на основании плана – документа
                    Ожидаемая приемка, или по факту. Процесс приема поставки оформляется документом "Приемка". Процедура
                    приемки товара включает в себя выгрузку товара в зоне
                    приемки, идентификацию и пересчет поступившего товара, приведение товара к стандарту складского
                    хранения и т.д. Как правило, документ "Приемка" оформляется
                    на основании планируемой поставки – "Ожидаемая приемка". В исключительных случаях товар может быть
                    принят по факту. "Приемка" может выполняться после
                    предварительного пересчета поступившего товара по местам или без него.
                </p>

                <p>
                    В случае отсутствия штрих кода на входящем товаре, можно выполнить его маркировку. Маркировку можно
                    выполнить на любом этапе товародвижения. Для этого
                    необходимо оформить документ "Маркировка", где будут сформированы штрих коды на товар и распечатаны
                    этикетки. На этапе создания плана приемки – документа
                    "Ожидаемая приемка" может быть известна информация о номерах контейнеров, ожидаемых к поступлению, и
                    их товарном составе. Данная особенность характерна в
                    основном для производственных складов. В этом случае приемка может выполняться в "доверительном"
                    режиме ("Доверительная приемка"). Товарный состав подобных
                    контейнеров, как правило, не пересчитывается при поступлении на склад, и приемка выполняется
                    поконтейнерно.
                </p>

                <p>
                    С применением терминалов сбора данных при обработке доверительной приемки производится сканирование
                    штрих кодов с этикеток контейнеров. Товарный состав при
                    этом по умолчанию соответствует плану, отраженному в Ожидаемой приемке. Если при приемке товара уже
                    известно, по какому заказу от покупателя принимаемый
                    товар будет отгружен, то возможно зарезервировать этот товар за этим заказом.
                </p>

                <p>
                    При поступлении на склад транзитных грузов оформляется приемка по грузовым местам. Транзитные грузы
                    принимаются под конкретный Заказ на отгрузку и не
                    подлежат пересчету по товарному составу. Если принимаемый товар учитывается в разрезе сроков
                    годности, то необходимо при приемке ввести в систему эти
                    параметры. Для осуществления возможности гарантийного возврата товара поставщику можно при приемке
                    зафиксировать серийные номера полученного товара.
                </p>

                <p>
                    Принятый на склад товар может быть еще раз проконтролирован и пересчитан с помощью задачи "Контроль
                    приемки". Контрольный пересчет может проводиться для
                    проверки соответствия принятого товара по количеству, а также для уточнения дополнительных
                    параметров товара. Так, например, в зоне приемки у ворот товар
                    может быть пересчитан только по количеству, а уже на этапе контроля приемки детализируется его
                    дополнительные параметры, такие как срок годности, серийные
                    номера.
                </p>

                <p>
                    После приемки товара подлежит размещению. Товар может размещаться на склад по факту завершения
                    пересчета всей поставки или по завершению приемки каждого
                    контейнера. В случае необходимости конечная ячейка-получатель может не планироваться, а размещение
                    производиться по факту с самостоятельным выбором ячейки
                    Кладовщиком с терминалом. Правила запуска автоматического планирования размещения настраиваются с
                    помощью механизма событий.
                </p>

                <p>
                    <b>Размещение. </b>В системе "1С:WMS Логистика. Управление складом" можно реализовать различные
                    стратегии размещения товара: автоматическое, размещение
                    через буфер, размещение ближе к зоне отбора; пополнение зоны отбора при размещении.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1675309298.png" alt=""/>

                <p>Правила размещения настраиваются на уровне стратегий размещения. Размещение товара на складе обычно
                    выполняется исходя из следующих принципов:</p>

                <ul>
                    <li>ABC-классификация товаров (товары с высокой оборачиваемостью располагаются ближе к зоне
                        комплектации готовых заказов для ускорения отбора);
                    </li>
                    <li>выделение зон для размещения и хранения по товарным группам, производителям, поклажедателям или
                        другим свойствам товара;
                    </li>
                    <li>
                        возможность или запрет смешивания разного товара или одного товара с разными аналитическими
                        свойствами в одной ячейке (разные сроки годности, партии,
                        серийные номера, качество и т.д.) при размещении;
                    </li>
                    <li>учет типов стеллажей, используемых для хранения товара. Например, размещение в узкопроходные
                        стеллажи через буферную зону;
                    </li>
                    <li>учет размещаемого товара по типу отбора (штучное хранение и хранение контейнеров);</li>
                    <li>
                        проверка наличия достаточного количества товара в зоне отбора при размещении, пополнение зоны
                        отбора принятым товаром (с раскладыванием принятых паллет
                        покоробочно в ячейках отбора или размещением паллет целиком);
                    </li>
                    <li>учет специфики товара (негабаритный товар, температурные особенности хранения, брак и т.д.).
                    </li>
                </ul>

                <p>
                    Все перечисленные принципы могут быть настроены в системе "1С:WMS Логистика. Управление складом" в
                    справочнике "Стратегии размещения". Результатом отработки
                    алгоритмов размещения, заданных на уровне стратегий, является созданные задачи на размещение товара.
                </p>

                <p>
                    <b>Перемещение</b>. Процесс внутреннего перемещения целых контейнеров, товара между контейнерами и
                    ячейками в системе оформляется с помощью задач на
                    перемещение. Для перемещения целых контейнеров и товарного состава контейнеров предусмотрены
                    отдельные задачи.&nbsp;
                </p>

                <p>
                    Задачи на перемещения используются для оформления любого перемещения товара по складу. Задачи на
                    перемещение могут создаваться автоматически по событию на
                    складе или вручную Диспетчером склада. Так, например, при обнаружении в процессе пересчета
                    бракованного товара, может быть автоматически создано задание на
                    перемещение данного товара в зону брака. Или автоматическое перемещение принятых предварительных
                    контейнеров в зону временного хранения.&nbsp;
                </p>

                <p>
                    При ручном создании задач на перемещение диспетчер склада может самостоятельно указать товар,
                    контейнер и ячейку-источник и ячейку-получатель. Созданные
                    вручную задания на перемещения могут быть отработаны с применением терминала сбора данных. Задачи на
                    перемещение могут создаваться в свободном режиме
                    непосредственно из окна терминала, когда решение о том, что необходимо переместить, откуда и куда,
                    принимает сотрудник склада самостоятельно.
                </p>
                <img src="https://cybernetica.kz/uploads/gallery/1979779321.png" alt=""/>

                <p>
                    В операциях по работе с контейнерами с использованием ТСД ("Перемещение контейнера", "Размещение
                    контейнера", "Подпитка контейнером", "Свободное перемещение
                    контейнера") выводится справочная информации по составу текущего, обрабатываемого контейнера. В
                    системе для просмотра истории перемещений товара в
                    контейнере предусмотрен соответствующий отчет. Штрихкодирование товаров, ячеек, контейнеров,
                    персонала; генерация, хранение и печать штрих кодов
                    (поддерживается генерации штрих кода "GS1 DataBar Expanded Stacked"); поддержка работы с
                    неуникальными штрих кодами. Отбор и отгрузка товара. В системе
                    реализованы различные стратегии отбора: кластерный, групповой; консолидация отборов в волны согласно
                    временным окнам отгрузки, в группы по схожим товарам, в
                    рейсы по маршрутам доставки. Отгрузка товара со склада осуществляется на основании плана отгрузки,
                    загруженного из корпоративной информационной системы.
                    План того, что должно быть отгружено со склада, содержится в документе "Заказ на отгрузку".
                    Возможными направлениями отгрузки могут быть отгрузка покупателю
                    (клиенту), перемещение на другие склады компании, возврат поставщику, отгрузка товара (сырья и
                    материалов) в производство. На основании информации о
                    планируемых отгрузках возможно проведение регламентных мероприятий по подготовке к более быстрой
                    комплектации данного заказа (например, подпитка ячеек
                    активной зоны). На основании заказа на отгрузку отгрузки производятся все дальнейшие операции по
                    данному заказу. "Заказы на отгрузку" могут быть объединены
                    в рейсы по маршрутам доставки. Данные о рейсах маршрута объезда транспортных средств содержаться в
                    документе "Рейс". Рейс может быть создан на основании
                    данных, полученных из системы корпоративного учета, системы управления доставкой, или Диспетчером
                    склада в "1С:WMS Логистика. Управление складом". На
                    основании "Заказа на отгрузку" выполняется подбор товара из ячеек хранения. Поиск ячеек, в которых
                    расположен товар по заказу, выполняется системой
                    автоматически. Правила запуска автоматического планирования отбора настраиваются с помощью механизма
                    событий. Для сокращения времени на сборку заказов и
                    количества подходов складских сотрудников при выполнении отбора "Заказы на отгрузку" могут
                    объединяться в волну. Волна – группировка заказов для совместного
                    отбора в разные контейнеры, соответствующие заказам. Объединение заказов в волны целесообразно
                    выполнять при штучной отгрузке, когда несколько заказов
                    должны быть подготовлены к одному времени отгрузки, и штучный товар по нескольким заказам отбирается
                    в контейнеры-грузы. Штучный товар может собираться по
                    нескольким "Заказам на отгрузку" в один контейнер, который будет разобран позаказно в отдельно
                    выделенной зоне с помощью задачи на сортировку. В данном
                    случае "Заказы на отгрузку" могут быть объединены в группу отбора. Для отбора штучного товара по
                    нескольким заказам могут быть заранее подготовлены
                    грузы-контейнеры под каждый заказ. Подобный отбор является кластерным. При кластерном отборе товара
                    система выдает подсказки, в какой контейнер, какой товар
                    необходимо разместить. При планировании отбора товара учитываются алгоритмы отбора, заданные в
                    стратегиях отбора. Планирование отбора на складе обычно
                    выполняется на основании следующих принципов:
                </p>

                <ul>
                    <li>
                        наличие выделенной зоны отбора. Как правило, под отбор товара выделяют нижний ярус стеллажей для
                        ускорения процесса отбора.&nbsp; Поиск товара по
                        заказам в первую очередь производится в данной зоне;
                    </li>
                    <li>
                        кратность отбора – какими единицами необходимо выполнять отбор товара: целыми паллетами,
                        коробами или штуками. Например, если заказанное количество
                        товара соответствует целой паллете, то отбор можно произвести сразу целой паллетой из зоны
                        резервного хранения;
                    </li>
                    <li>учет типов стеллажей, используемых для хранения товара. Например, отбор из гравитационных
                        стеллажей производится по принципу LIFO;
                    </li>
                    <li>учет сроков годности при отборе товара. Анализ требований по запасу срока годности для
                        контрагента заказа.
                    </li>
                </ul>

                <p>Для осуществления возможности гарантийного возврата товара от покупателя на этапе отбора можно
                    зафиксировать серийные номера отобранного товара.</p>

                <p>
                    На этапе создания "Заказа на отгрузку" может быть известна информация о номерах контейнеров, которые
                    необходимо отгрузить, и их товарном составе. В данном
                    случае планирование отбора производится по конкретному контейнеру, указанному в заказе.
                </p>

                <p>
                    Задача на отбор выполняется с применением терминалов сбора данных. В качестве резервной технологии
                    может быть рассмотрена технология работы по "бумажным"
                    носителям.
                </p>

                <p>
                    По результатам отбора товар может быть перемещен в выделенную зону контроля и упаковки. Зона
                    контроля и упаковки может быть оборудована рабочими местами с
                    подключенными сканерами считывания штрихкодов, с помощью которых производится сканирование
                    отобранного товара и проверка на соответствие заказу. Процедура
                    контроля может быть произведена и с применением терминалов сбора данных. В процессе выполнения
                    процедуры контроля отобранный товар может быть упакован в
                    транспортные места – контейнеры с печатью упаковочного листа для передачи транспортной компании, в
                    собственный магазин или конечному клиенту.
                </p>

                <p>
                    По результатам отбора товара в один контейнер по нескольким заказам, объединенным в группу,
                    выполняется последующая процедура сортировки. В процессе
                    сортировки товар раскладывается по заказам для последующей отправки клиентам.
                </p>

                <p>
                    Проконтролированный и упакованный товар может быть еще раз пересчитан у ворот отгрузки или при
                    загрузке в машину. В данном случае пересчет производится уже
                    не по товарному составу, а по количеству отгружаемых грузовых мест.
                </p>

                <ul>
                    <li>Упаковка отобранного товара в грузовые места; шаблоны для настройки правил упаковки на паллету
                        "под клиента".
                    </li>
                    <li>Планирование рейсов по маршрутам доставки при отгрузке.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/1654878315.png" alt=""/>
                <p>
                    Контроль качества принятого товара. Контроль качества, отобранного и упакованного товара; контроль
                    при загрузке в машину. В системе предусмотрено несколько
                    типов задач на пересчет:
                </p>
                <ul>
                    <li>
                        инвентаризация ячейки. При проведении инвентаризации ячейки пересчету подлежат все контейнеры и
                        товары, расположенные в ячейке. При инвентаризации
                        ячейки может производиться пересчет как по количеству контейнеров в ячейке, так и по товарному
                        составу контейнера;
                    </li>
                    <li>
                        инвентаризация контейнеров. При проведении инвентаризации контейнеров производится пересчет
                        состава определенного контейнера, по которому создана
                        задача;
                    </li>
                    <li>
                        инвентаризация товара. При проведении инвентаризации товара производится пересчет конкретного
                        товара во всех контейнерах и ячейках, в которых данный
                        товар расположен;
                    </li>
                    <li>контроль приемки. Задача по контролю приемки предназначена для пересчета вновь принятого на
                        склад товара;
                    </li>
                    <li>контроль отгрузки. Задача по контролю отгрузки предназначена для пересчета отгружаемого под
                        заказ клиента товара со склада;
                    </li>
                    <li>
                        ­контроль качества. Задача по контролю качества предназначена для пересчета и проверки состояния
                        товара на складе. Контроль качества может быть проведен
                        на любой стадии обработки товара: в зоне приемки на поступивший товар, в процессе хранения или
                        отгрузки.
                    </li>
                </ul>

                <p>
                    На больших складах, оперирующих в основном паллетным хранением, инвентаризация может проводиться "на
                    лету" с пересчетом паллет по количеству, расположенных
                    в ячейках. В данном случае состав паллет может не пересчитываться. Для проведения подобной
                    инвентаризации используется задача на пересчет с типом
                    Инвентаризация контейнеров. Для пересчета товарного состава ячеек, контейнеров, или конкретного
                    товара на складе используется задача на пересчет с типом
                    Инвентаризация состава контейнеров. Принятый на склад товар может быть проконтролирован по
                    количеству и качеству с помощью задачи на "Контроль приемки".
                    Отобранный под заказ клиента товар также может быть проконтролирован с помощью задачи на "Контроль
                    отгрузки".
                </p>

                <p>
                    Для проверки и контроля качества товара на любом этапе складской грузообработки может быть проведена
                    процедура Контроля качества. Проведение контроля
                    качества товара, как правило, характерно для продуктовых складов, и проводится отдельными
                    сотрудниками отдела контроля качества. Процедура контроля и
                    изменения качества на других складах также применяется при обнаружении бракованного товара и
                    необходимости его списания или утилизации. В результате
                    проведения данной операции может измениться статус товара.
                </p>

                <p>
                    Подпитка. При необходимости в пополнении зоны отбора товара в системе выполняется задача на
                    подпитку. Подпитка выполняется под потребность "Заказа на
                    отгрузку" или в любое время согласно регламенту склада. Подпитка может выполняться при достижении
                    минимального количества контейнеров (товара) до
                    максимального количества контейнеров (товаров) в области отбора. Значения минимального и
                    максимального количества товаров в зонах отбора рассчитываются
                    автоматически на основании статистических данных.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/389451539.png" alt=""/>

                <p>
                    Минимальный и максимальный уровень остатков задаются для каждого товара. Индивидуальные параметры
                    подпитки настраиваются на уровне товара и выделенной зоны
                    или ячеек отбора для товара. Подпитка зоны (фиксированных ячеек) отбора может производиться и зоны
                    основного хранения, зоны ближнего буфера или зоны
                    приемки. Правила подпитки определяются в стратегиях подпитки. Задачи на подпитку выполняются с
                    помощью терминала сбора данных. В качестве резерва может
                    применяться технология выдачи задач на бумажном носителе.
                </p>

                <p>Инвентаризация произвольной области склада, пустых ячеек, товара/товарной группы.</p>

                <p>
                    Проведение инвентаризации с использованием системы "1С:WMS Логистика. Управление складом" не требует
                    полной остановки работы склада, и может проводиться по
                    ограниченной области ячеек (проезду, стеллажу, ярусу) или определенной товарной группе. Блокировка
                    ячейки на момент проведения пересчета не производится,
                    что позволяет не останавливать работу по инвентаризируемой ячейке для выполнения других складских
                    операций.
                </p>

                <p>
                    Оптимизация использования складских площадей – компрессия склада. Для экономии места в стеллажах на
                    складе обычно проводится процедура уплотнения товара.
                    Компрессия (или уплотнение) – перемещение товара из нескольких ячеек в одну с целью более
                    эффективного использования складских площадей. Стратегия
                    компрессии включает в себя список алгоритмов компрессии и условий их выполнения.
                </p>

                <p>Возможные алгоритмы компрессии:</p>

                <ul>
                    <li>
                        Восстановление класса АВС: при выполнении учитывается класс ABC так, чтобы товар класса А
                        оказался в ячейках класса А, а товар класса С в ячейках класса
                        С. При этом анализируются только подобранные по условию остатки;
                    </li>
                    <li>Вытеснение в другие зоны: система планирует перемещение подобранных по условию остатков в
                        указанные зоны склада;
                    </li>
                    <li>
                        Вытеснение из зоны отбора: система анализирует пул документов "Заказ на отгрузку" и их
                        потребности в товаре за определенный период. Если на товар нет
                        потребности или потребность меньше количества товара в зоне, то товар будет перемещен из
                        указанной зоны. При этом анализируются только подобранные по
                        условию остатки;
                    </li>
                    <li>Совмещение одинаковых остатков: планируется перемещение подобранных в условии остатков товара к
                        любым остаткам такого же товара в указанной зоне;
                    </li>
                    <li>
                        Совмещение различных остатков: планируется перемещение подобранных в условии остатков товара к
                        остаткам другого товара, также подобранным в этом
                        условии.
                    </li>
                </ul>

                <p>В системе предусмотрен механизм планирования автоматического выполнения компрессии в соответствии с
                    заданным расписанием и необходимой периодичностью.</p>

                <p>Работа с терминалами сбора данных (ТСД)</p>

                <ul>
                    <li>работа без операторов склада;<br/></li>
                    <li>онлайн-режим работы склада;</li>
                    <li>применение ТСД при обработке всех складских задач;</li>
                    <li>применение ТСД для выполнения вспомогательных операций;</li>
                    <li>помощник первоначальной настройки ТСД;</li>
                    <li>механизм автоматического обновление приложения мобильного клиента;</li>
                    <li>рабочее место диспетчера ТСД для контроля текущего состояния терминалов сбора данных;</li>
                    <li>инструмент «Эмулятор мобильного клиента», позволяющий выполнять складские операции аналогично
                        выполнению операций на терминале.
                    </li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/2081978948.png" alt="" srcSet=""/>

                <p>Управление ресурсами</p>
                <ul>
                    <li>управление задачами склада: классификация и приоритезация;</li>
                    <li>
                        <p>­автоматическое распределение и выдача задач;</p>
                    </li>
                    <li>
                        <p>­контроль исполнения задач: фиксация исполнителя, длительности, простоев;</p>
                    </li>
                    <li>
                        <p>фиксация ошибок при выполнении складских задач;</p>
                    </li>
                    <li>
                        <p>назначение прав доступа в зависимости от квалификации персонала и зон доступа;</p>
                    </li>
                    <li>
                        <p>расчет выработки складского персонала по объему, весу, количеству операций;&nbsp;</p>
                    </li>
                    <li>
                        <p>анализ эффективности и продуктивности работы персонала (KPI);</p>
                    </li>
                    <li>
                        <p>­расчет необходимой численности персонала на смену;</p>
                    </li>
                    <li>управление складской техникой.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/2059883569.png" alt="" srcSet=""/>

                <p>Оповещение пользователей системы</p>
                <p>
                    В решении "1С:WMS" реализована возможность оповещения пользователей системы о возникающих складских
                    событиях на e-mail, через SMS или Telegram.А также
                    реализована возможность отправить сообщение из 1С пользователям ТСД и наоборот.
                </p>

                <p><b>Расчет услуг ответственного хранения</b><br/></p>

                <ul>
                    <li>
                        <p>учет товара в разрезе владельцев;</p>
                    </li>
                    <li>
                        <p>задание тарифов по складским операциям по каждому владельцу;</p>
                    </li>
                    <li>
                        <p>расчет стоимости услуг по каждой операции.&nbsp;&nbsp;</p>
                    </li>
                </ul>

                <p>
                    <b>Управление двором/Yard Management</b>
                </p>

                <p>
                    Функционал "1С:WMS Логистика. Управление складом" помимо автоматизации задач по складской обработке
                    позволяет управлять территорией, примыкающей к складу.
                    Данный функционал позволяет управлять движением транспортных средств, поступающих на территорию
                    склада, а именно:
                </p>

                <ul>
                    <li>регистрация факта въезда и выезда транспортных средств на территорию склада;</li>
                    <li>формирование и выдача пропусков;</li>
                    <li>определение стояночных мест&nbsp;для разных моделей транспортных средств в автоматическом или
                        ручном режимах;
                    </li>
                    <li>расписание ворот погрузки/ выгрузки. Постановка на ворота с учетом моделей транспортных
                        средств;
                    </li>
                    <li>контроль ведения&nbsp;погрузочно-разгрузочных работ;</li>
                    <li>управление движением транспортных средств на складской территории;</li>
                    <li>учет и анализ графиков прибытия/убытия ТС;</li>
                    <li>автоматическое назначение окна погрузки/разгрузки ко времени поступления ТС на склад;</li>
                    <li>контроль работы склада;</li>
                    <li>монитор руководителя склада;</li>
                    <li>монитор заказов и задач;</li>
                    <li>монитор диспетчеров приемки и отгрузки;</li>
                    <li>монитор ресурсов;</li>
                    <li>аналитика работы склада: заполненность, состояние остатков, оптимизация хранения.</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/500010781.png" alt=""/>

                <b>Аналитическая отчетность</b>

                <p>
                    По факту обработки складских операций функционал системы "1С:WMS Логистика. Управление складом"
                    позволяет выполнить:
                </p>

                <ul>
                    <li>мониторинг состояния заказов и задач к выполнению;</li>
                    <li>анализ заполненности склада в разрезе зон и ячеек хранения;</li>
                    <li>анализ текущего состояния склада в разрезе адресного хранения;</li>
                    <li>план-фактный анализ ожидаемого к поступлению товара и по факту принятого на склад;</li>
                    <li>план-фактный анализ заказанного и отгруженного товара со склада;</li>
                    <li>анализ выработки складского персонала.&nbsp;</li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/1615856770.png" alt=""/>
                <img src="https://cybernetica.kz/uploads/gallery/677207747.png" alt=""/>

                <p>
                    Мониторинг заказов и задач осуществляется с помощью рабочих мест диспетчеров приемки, отгрузки и
                    задач. Все аналитические функции реализованы при помощи отчетов, которые разработаны с
                    использованием системы компоновки данных и могут вариативно настраиваться пользователями функционала
                    подсистемы. Отчеты сгруппированы в зависимости от назначения в соответствующих подсистемах
                    конфигурации.
                </p>

                <b>Анализ показателей эффективности работы склада и персонала</b>
                <p>
                    Для обеспечения постоянного мониторинга эффективности работы склад и возможности оперативного
                    принятия решений, основанных на объективных данных в "1С:WMS" реализована подсистема "Анализ
                    показателей эффективности".
                </p>

                <p>
                    Функционал подсистемы позволяет:
                </p>

                <ul>
                    <li>
                        <p>
                            Определять показатели эффективности склада и складских сотрудников
                        </p>
                    </li>
                    <li>
                        <p>
                            Назначать общие показатели эффективности для группы сотрудников и персональные для
                            сотрудника
                        </p>
                    </li>
                    <li>
                        <p>
                            Устанавливать способ и периодичность расчета показателей
                        </p>
                    </li>
                    <li>
                        <p>
                            Устанавливать нормативные значения показателей эффективности
                        </p>
                    </li>
                    <li>
                        <p>
                            Автоматически рассчитывать фактические показатели эффективности склада и складских
                            сотрудников
                        </p>
                    </li>
                    <li>
                        <p>
                            Формировать отчеты Показатели эффективности склада/ сотрудников, Динамика показателей
                            эффективности склада/ сотрудников
                        </p>
                    </li>
                </ul>

                <img src="https://cybernetica.kz/uploads/gallery/398413642.png" alt=""/></div>
        </div>
    )
}